import React from "react";
import { useCallback } from "react";
import Box from "@mui/material/Box";
import Grid from '@mui/material/Unstable_Grid2';
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

import { useGetSectionsQuery, useUserLoginMutation } from "./loginAPI";

import logoImage from "./lavazza-logo-blu.png";
import config from "../../config";


const { envs } = config;
const { login: apiPath } = config.endpoints;

const Login = () => {
  const [userLogin, { isSuccess: isTokenSuccess, data: userTokens }] = useUserLoginMutation();
  const { data } = useGetSectionsQuery(userTokens, { skip: !isTokenSuccess });

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    userLogin({
      username: data.get("username"),
      password: data.get("password"),
    });
  };

  const handleSSOLogin = useCallback(() => {
    const redirectUri = `${window.location.protocol}//${window.location.host}/callback`;
    const clientId = envs.keycloakSSO.client_id; 
  
    const loginUrl = `${envs.apiUrl + apiPath.userLoginSSO}?client_id=${clientId}&response_type=code&kc_idp_hint=saml&redirect_uri=${redirectUri}`;
    
    // Reindirizza l'utente a Keycloak per l'autenticazione SSO
    window.location.href = loginUrl;
  }, []);

  return (
    <Grid container component="main" sx={{ height: "100vh" }}>
      <Grid
        item
        xs={false}
        sm={4}
        md={7}
        sx={{
          backgroundImage: "url(https://source.unsplash.com/random?wallpapers)",
          backgroundRepeat: "no-repeat",
          backgroundColor: (t) =>
            t.palette.mode === "light" ? t.palette.grey[50] : t.palette.grey[900],
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <Grid xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <Box
          sx={{
            my: 8,
            mx: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={logoImage}
            alt="image"
            style={{ 
              width: "65%", 
              height: "50%", 
            }}
          />
          <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="username"
              name="username"
              autoComplete="username"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <Button type="submit" fullWidth variant="outlined" sx={{ mt: 3, mb: 2 }}>
              Sign In
            </Button>
            <Button
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={handleSSOLogin}
          >
            Sign In with Lavazza SSO
          </Button>
          </Box>
          
        </Box>
      </Grid>
    </Grid>
  );
};
export default Login;